// Utility to clean up job description HTML for all pages
export default function cleanJobDescription(html) {
  if (!html) return "";
  let cleaned = html
    .replace(/<li>(\s|&nbsp;|<br\s*\/?>)*<\/li>/gi, "") // Remove empty <li>
    .replace(/(<ul>\s*<\/ul>)/gi, "") // Remove empty <ul>
    .replace(/(<br\s*\/?>\s*){2,}/gi, "<br>") // Collapse multiple <br> to one
    .replace(/\s+<\/li>/g, "</li>"); // Remove trailing whitespace before </li>
  return cleaned.trim();
}
